export const clampIndex = (i: number, len: number) =>
  len <= 0 ? 0 : Math.max(0, Math.min(i, len - 1));
